export default __webpack_public_path__ + "static/media/done.1f8d0c95.png";